import type { WorkAssignment } from "../types/work-assignment.types";
import type { EmployeeOptionAttributes } from "features/Employees/components/EmployeeSelectComponents";
import { workAssignmentAssigneeId } from "../utils/workAssignmentNormalize";

/** Stable primary row for shared fields (dates, role, remarks). */
export function primaryWorkAssignment(
  assignments: WorkAssignment[],
): WorkAssignment | null {
  if (!assignments.length) return null;
  return [...assignments].sort((a, b) => a.id - b.id)[0];
}

export function defaultOptionsFromAssignments(
  assignments: WorkAssignment[],
): EmployeeOptionAttributes[] {
  const seen = new Map<number, EmployeeOptionAttributes>();
  for (const a of assignments) {
    const u = a.user;
    const id = u?.id ?? workAssignmentAssigneeId(a);
    if (id == null || !Number.isFinite(Number(id))) continue;
    const numId = Number(id);
    if (!Number.isFinite(numId) || numId <= 0) continue;
    if (seen.has(numId)) continue;
    if (u?.id != null) {
      const name =
        [u.firstName, u.lastName].filter(Boolean).join(" ").trim() ||
        u.email ||
        `User #${numId}`;
      seen.set(numId, {
        value: numId,
        label: name,
        code: undefined,
        firstName: u.firstName,
        lastName: u.lastName,
        avatar: u.avatar ?? undefined,
      });
    } else {
      seen.set(numId, {
        value: numId,
        label: `User #${numId}`,
        code: undefined,
        firstName: undefined,
        lastName: undefined,
        avatar: undefined,
      });
    }
  }
  return Array.from(seen.values());
}

/** User ids for create/reassign payloads (option rows may use `value` = employee id with `userId` set). */
export function userIdsFromAssignments(assignments: WorkAssignment[]): number[] {
  return defaultOptionsFromAssignments(assignments).map((o) =>
    Number(o.userId ?? o.value),
  );
}
